import React from 'react';
import { Link } from 'react-router-dom';

const navStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '1.5rem 2rem',
  background: 'rgba(255,255,255,0.04)',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  zIndex: 2,
};
const leftStyle = { display: 'flex', gap: '2rem', alignItems: 'center' };
const rightStyle = { display: 'flex', alignItems: 'center' };
const linkStyle = {
  color: '#fff',
  background: 'transparent',
  border: 'none',
  textDecoration: 'none',
  fontWeight: 500,
  fontSize: '1.1rem',
  letterSpacing: '0.04em',
  padding: '0.25rem 0.5rem',
  borderRadius: '3px',
  cursor: 'pointer',
  outline: 'none',
  transition: 'background 0.2s, color 0.2s',
};
const activeLink = {
  ...linkStyle,
  background: 'rgba(255,255,255,0.13)',
  color: '#fff',
  fontWeight: 700,
  boxShadow: '0 2px 12px 0 rgba(255,255,255,0.08)'
};

export default function LandingNavbar({ section, setSection }) {
  return (
    <nav style={navStyle}>
      <div style={leftStyle}>
        <button style={section==='Home'?activeLink:linkStyle} onClick={()=>setSection('Home')}>Home</button>
        <button style={section==='Welcome'?activeLink:linkStyle} onClick={()=>setSection('Welcome')}>Welcome</button>
        <button style={section==='Offerings'?activeLink:linkStyle} onClick={()=>setSection('Offerings')}>Offerings</button>
        <button style={section==='Events'?activeLink:linkStyle} onClick={()=>setSection('Events')}>Events</button>
        <button style={section==='Therapies'?activeLink:linkStyle} onClick={()=>setSection('Therapies')}>Therapies</button>
        <button style={section==='App'?activeLink:linkStyle} onClick={()=>setSection('App')}>App</button>
        <button style={section==='Store'?activeLink:linkStyle} onClick={()=>setSection('Store')}>Store</button>
        <button style={section==='Contact'?activeLink:linkStyle} onClick={()=>setSection('Contact')}>Contact</button>
      </div>
      <div style={rightStyle}>
        <Link to="/login" style={linkStyle}>Login</Link>
      </div>
    </nav>
  );
} 